export class GenericDocEditingLockDto {
  generic_doc_hdr_guid: string | null;
}
